import React from "react";
import { Form, Input } from "@xala/common-ui";
import { useTranslation } from "react-i18next";
import { INotificationField } from "./INotificationField";

export const UrlContentField = ({
  notification,
  isEditMode,
  isHidden,
}: INotificationField) => {
  const { t } = useTranslation();

  if (isHidden) {
    return null;
  }

  return (
    <Form.Item
      name="UrlContent"
      label={t("NOTIFICATION_URL_CONTENT_FIELD")}
      key="UrlContent"
      initialValue={isEditMode ?? notification?.UrlContent}
    >
      <Input placeholder={t("NOTIFICATION_URL_CONTENT_INPUT_FIELD")} />
    </Form.Item>
  );
};
